import { API_BASE_URL, AxiosUtil } from "@/Utils/axios.util";
import { AxiosResponse } from "axios";
import { PlatformLogsFilters } from "@/interfaces/panel/platform-logs.model";

const BASE_URL = process.env.NODE_ENV === "development"
    ? `${API_BASE_URL}/api/admin/platform-logs`
    : "https://sayyarpay.top/api/admin/platform-logs";

async function GetPlatformLogs(filters?: PlatformLogsFilters): Promise<AxiosResponse> {
    const url = BASE_URL;
    const params: Record<string, unknown> = {};

    if (filters) {
        // Pagination
        if (filters.page) params.page = filters.page;
        if (filters.pageSize) params.pageSize = filters.pageSize;

        // Sorting
        if (filters.sortBy) params.sortBy = filters.sortBy;
        if (filters.sortOrder) params.sortOrder = filters.sortOrder;

        // Type filters
        if (filters.type) {
            if (Array.isArray(filters.type)) {
                params.type = filters.type.join(",");
            } else {
                params.type = filters.type;
            }
        }

        // Status filters
        if (filters.status) {
            if (Array.isArray(filters.status)) {
                params.status = filters.status.join(",");
            } else {
                params.status = filters.status;
            }
        }

        // Action filters
        if (filters.action) {
            if (Array.isArray(filters.action)) {
                params.action = filters.action.join(",");
            } else {
                params.action = filters.action;
            }
        }

        if (filters.actionContains) params.actionContains = filters.actionContains;

        // User filters
        if (filters.userId) params.userId = filters.userId;
        if (filters.targetUserId) params.targetUserId = filters.targetUserId;
        if (filters.adminId) params.adminId = filters.adminId;
        if (filters.userEmail) params.userEmail = filters.userEmail;
        if (filters.targetEmail) params.targetEmail = filters.targetEmail;
        if (filters.adminEmail) params.adminEmail = filters.adminEmail;

        // Other filters
        if (filters.referenceId) params.referenceId = filters.referenceId;
        if (filters.search) params.search = filters.search;
        if (filters.from) params.from = filters.from;
        if (filters.to) params.to = filters.to;
        if (filters.ip) params.ip = filters.ip;
        if (filters.device) params.device = filters.device;

        // Boolean filters
        if (filters.isRead !== undefined) params.isRead = filters.isRead;
        if (filters.hasError !== undefined) params.hasError = filters.hasError;
        if (filters.includeTotals !== undefined) params.includeTotals = filters.includeTotals;
        if (filters.withRelations !== undefined) params.withRelations = filters.withRelations;
    }

    return AxiosUtil.get(url, { params });
}

async function GetUserStatement(userId: string, filters?: {
    page?: number;
    pageSize?: number;
    from?: string;
    to?: string;
    category?: "charge" | "payment" | "withdraw" | "transfer" | "commission" | "settlement" | "crypto" | "all";
    currency?: string;
    minAmount?: number;
    maxAmount?: number;
    status?: "SUCCESS" | "FAILED" | "PENDING" | "CANCELLED";
    action?: string;
}): Promise<AxiosResponse> {
    const url = `${BASE_URL}/user-statement`;
    const params: Record<string, unknown> = { userId };

    if (filters) {
        if (filters.page) params.page = filters.page;
        if (filters.pageSize) params.pageSize = filters.pageSize;
        if (filters.from) params.from = filters.from;
        if (filters.to) params.to = filters.to;
        if (filters.category) params.category = filters.category;
        if (filters.currency) params.currency = filters.currency;
        if (filters.minAmount !== undefined) params.minAmount = filters.minAmount;
        if (filters.maxAmount !== undefined) params.maxAmount = filters.maxAmount;
        if (filters.status) params.status = filters.status;
        if (filters.action) params.action = filters.action;
    }

    return AxiosUtil.get(url, { params });
}

export const platformLogsRequests = {
    GetPlatformLogs,
    GetUserStatement,
};
